/** @format */

// Vue and Inertia
/**
 * Vuetify
 */
import "../css/vendor/vuetify.scss"

import { createInertiaApp, Head } from "@inertiajs/vue3"
// I18n
import { i18nVue } from "laravel-vue-i18n"
import { createApp, h } from "vue"
import { createVuetify } from "vuetify"
import * as components from "vuetify/components"
import * as directives from "vuetify/directives"

import { ZiggyVue } from "../../vendor/tightenco/ziggy/dist/vue.m"
import { ctThemeDark, ctThemeLight } from "./ctTheme"
export const DEFAULT_THEME = 'ctThemeLight'
/**
 * End vuetify
 */


// Default components : These are essentially overloaded vuetify components
import Field from "./Components/Default/BaseField.vue"
import BreadCrumbs from "./Components/Default/BreadCrumbs.vue"
import DialogLoader from "./Components/Default/DialogLoader.vue"
import FieldLoader from "./Components/Default/FieldLoader.vue"
import Skeleton from "./Components/Default/Skeleton.vue"
import SkeletonCardLoader from "./Components/Default/SkeletonCardLoader.vue"

// Init app
createInertiaApp({
    title: (title) => (title ? "KeyPredict - " + `${title}` : "Central Test"),
    resolve: (name) => import(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        const vuetify = createVuetify({
            components,
            directives,
            theme: {
                defaultTheme: DEFAULT_THEME,
                themes: {
                    ctThemeLight,
                    ctThemeDark,
                },
            },
            icons: {
                defaultSet: "mdi",
            }
        })
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(vuetify)
            .component("AppHead", Head)
            .component("BreadCrumbs", BreadCrumbs)
            .component("DialogLoader", DialogLoader)
            .component("Field", Field)
            .component("FieldLoader", FieldLoader)
            .component("Skeleton", Skeleton)
            .component("SkeletonCardLoader", SkeletonCardLoader)
            .use(i18nVue, { resolve: (lang) => import(`../../lang/${lang}.json`) })
            .mount(el)
    },
    progress: {
        delay: 250,
        /*
         * Theme definition
         */
        color: "#68E1FD",
        includeCSS: true,
    },
})
